import React, { useEffect, useRef, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { ChatsContextImport } from "../../../../provider/chats/chats/chats/ChatsContextProvider";
import {
  IconImageAsset,
  IconNormal,
  IconCircleFilledIcon,
} from "../../../../widget/common/ui/Icon";
import { TextBlock } from "../../../../widget/common/ui/Text";
import AppTranslation from "../../../../service/app_translation/AppTranslation";
import { GroupChatsContextImport } from "../../../../provider/chats/chats/group_chats/GroupChatsContextProvider";
import {
  GroupChatExitFooter,
  GroupChatNoAccessFooter,
} from "./ConversationFooterGroups";
import { DepartmentChatsContextImport } from "../../../../provider/chats/chats/department_chats/DepartmentChatsContextProvider";
import { TeamChatsContextImport } from "../../../../provider/chats/chats/team_chats/TeamChatsContextProvider";
import { TeamResults } from "../../../../model/chats/TeamConversationDetailsModel";
import { DepartmentResults } from "../../../../model/chats/DepartmentConversationDetailsModel";
import { GroupResults } from "../../../../model/chats/GroupConversationDetailsModel";
import { useSelector } from "react-redux";
import { RootState } from "../../../../libraries/state_reducers/store";
import UtilityHelper from "../../../../service/utilities/UtilityHelper";
import { ImageEditorPick } from "../../../../service/image_editor/ImageEditor";
import AudioRecorder from "../../../../service/audio_recorder/AudioRecorder";
import AppTheme from "../../../../service/app_config/AppTheme";
import { TimerMinutesSeconds } from "../../../../widget/common/ui/Timer";
import FileDocumentPicker from "../../../../service/file_picker/FileDocumentPicker";
import ModalKeys from "../../../../const/ModalKeys";
import { ResponsiveDeviceType } from "../../../../widget/layouts/ScreenMedia";
import { useDispatch } from "react-redux";
import {
  addModal,
  ModalInterface,
} from "../../../../libraries/state_reducers/widget/ModalsReducer";
import Div from "../../../../widget/common/ui/Div";
import { messageDeleteEveryoneAction } from "../../../../libraries/state_reducers/chats/ChatsReducer";
import { TeamMessage } from "../../../../model/chats/TeamConversationMessageModel";
import { Message } from "../../../../model/chats/GroupConversationMessageModel";
import { ReplyMessageDetailModel } from "../../../../model/chats/ReplyMessageDetailModel";
import { LogoImage } from "../../../../widget/common/ui/Logo";
import { textCase } from "../../../../service/ui/UI";

///////////////////////////////////////////////////////////////////////////////////////////////////////////
export const ChatFooter = () => {
  const { chatSelected } = ChatsContextImport();

  const conversationDetailGroupSelector = useSelector(
    (state: RootState) => state.chats.conversationDetailGroup
  );

  const teamChatsContextImport = TeamChatsContextImport();
  const departmentChatsContextImport = DepartmentChatsContextImport();
  const groupChatsContextImport = GroupChatsContextImport();

  const flag: string = chatSelected?.flag! ?? "1";

  const [teamConversationDetail, setTeamConversationDetail] =
    useState<TeamResults>(teamChatsContextImport.conversationDetail!);

  const [departmentConversationDetail, setDepartmentConversationDetail] =
    useState<DepartmentResults>(
      departmentChatsContextImport.conversationDetail!
    );

  const [groupStatus, setGroupStatus] = useState<string>(
    groupChatsContextImport.conversationDetail?.status ?? "0"
  );

  const [groupConversationDetail, setGroupConversationDetail] =
    useState<GroupResults>(groupChatsContextImport.conversationDetail!);

  ////////////////////////////////////////////////////////////////////////
  //
  //TEAM
  useEffect(() => {
    if (
      teamChatsContextImport.conversationDetail != null &&
      ["1", "4"].includes(flag)
    ) {
      setTeamConversationDetail(teamChatsContextImport.conversationDetail!);
    }
    // eslint-disable-next-line
  }, [teamChatsContextImport.conversationDetail]);

  //
  // DEPT
  useEffect(() => {
    if (
      departmentChatsContextImport.conversationDetail != null &&
      flag === "2"
    ) {
      setDepartmentConversationDetail(
        departmentChatsContextImport.conversationDetail!
      );
    }
    // eslint-disable-next-line
  }, [departmentChatsContextImport.conversationDetail]);

  //
  // GROUP
  useEffect(() => {
    if (groupChatsContextImport.conversationDetail != null && flag === "3") {
      setGroupConversationDetail(groupChatsContextImport.conversationDetail!);
      setGroupStatus(groupChatsContextImport.conversationDetail?.status!);
    }
    // eslint-disable-next-line
  }, [groupChatsContextImport.conversationDetail]);

  useEffect(() => {
    if (conversationDetailGroupSelector != null && flag === "3") {
      setGroupConversationDetail(conversationDetailGroupSelector);
      setGroupStatus(conversationDetailGroupSelector.status!);
    }
    // eslint-disable-next-line
  }, [conversationDetailGroupSelector]);

  ////////////////////////////////////////////////////////////////////////

  return (
    <>
      {flag === "3" && groupConversationDetail != null && (
        <>
          {groupStatus == "1" ? (
            <>
              {groupChatsContextImport.longPressStatus &&
              groupChatsContextImport.selectedMesasgeIds.length > 0 ? (
                <ChatFooterSend />
              ) : (
                <GroupChatNoAccessFooter />
              )}
            </>
          ) : (
            <GroupChatExitFooter />
          )}
        </>
      )}

      {flag === "2" && departmentConversationDetail != null && (
        <>
          {(departmentConversationDetail?.conv_settings?.block_details
            ?.my_block_status ?? "0") === "0" &&
          (departmentConversationDetail?.conv_settings?.block_details
            ?.participant_block_status ?? "0") === "0" &&
          (departmentConversationDetail?.conv_settings?.own_auto_reply_status ??
            "0") === "0" ? (
            <ChatFooterSend />
          ) : (departmentConversationDetail?.conv_settings
              ?.own_auto_reply_status ?? "0") === "1" ? (
            <ChatFooterRestrict title="auto_reply_enabled" />
          ) : (departmentConversationDetail?.conv_settings?.block_details
              ?.my_block_status ?? "0") === "1" ? (
            <ChatFooterRestrict title="unblock" />
          ) : (departmentConversationDetail?.conv_settings?.block_details
              ?.participant_block_status ?? "0") === "1" ? (
            <ChatFooterRestrict title="you_cant_reply_to_this_conversation" />
          ) : (
            <></>
          )}
        </>
      )}

      {["1", "4"].includes(flag) && teamConversationDetail != null && (
        <>
          {(teamConversationDetail?.conv_settings?.block_details
            ?.my_block_status ?? "0") === "0" &&
          (teamConversationDetail?.conv_settings?.block_details
            ?.participant_block_status ?? "0") === "0" &&
          (teamConversationDetail?.conv_settings?.own_auto_reply_status ??
            "0") === "0" ? (
            <ChatFooterSend />
          ) : (teamConversationDetail?.conv_settings?.own_auto_reply_status ??
              "0") === "1" ? (
            <ChatFooterRestrict title="auto_reply_enabled" />
          ) : (teamConversationDetail?.conv_settings?.block_details
              ?.my_block_status ?? "0") === "1" ? (
            <ChatFooterRestrict title="unblock" />
          ) : (teamConversationDetail?.conv_settings?.block_details
              ?.participant_block_status ?? "0") === "1" ? (
            <ChatFooterRestrict title="you_cant_reply_to_this_conversation" />
          ) : (
            <></>
          )}
        </>
      )}
    </>
  );
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////
const ChatFooterSend = () => {
  const teamChatsContextImport = TeamChatsContextImport();
  const departmentChatsContextImport = DepartmentChatsContextImport();
  const groupChatsContextImport = GroupChatsContextImport();

  const dispatch = useDispatch();

  const { toggleMediaOption, chatSelected, handleTypingMessage, userId } =
    ChatsContextImport();

  const messageHeightDefault: number = 60;
  const messageMaxDefault: number = 100;

  const textareaMessageRef = useRef<HTMLTextAreaElement | null>(null);

  const [messageHeight, setMessageHeight] =
    useState<number>(messageHeightDefault);
  const [isRunning, setIsRunning] = useState<boolean>(false);

  const audioSecondsRef = useRef<number>(0);

  const [textMessage, setTextMessage] = useState<string>("");
  const [recordingStatus, setRecordingStatus] = useState<boolean>(false);
  const [cancelRecording, setCancelRecording] = useState<boolean>(false);

  const messageHandleChange = (
    event: React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    const text: string = event.target.value.toString();
    setTextMessage(text);
    handleTypingMessage("1", true);
  };

  const sendTextMessage = () => {
    if (chatSelected != null) {
      const flag: string = chatSelected?.flag!;

      if (["1", "4"].includes(flag)) {
        teamChatsContextImport.sendTextMessage(textMessage, () => {
          setTextMessage("");
        });
      } else if (flag === "2") {
        departmentChatsContextImport.sendTextMessage(textMessage, () => {
          setTextMessage("");
        });
      } else if (flag === "3") {
        groupChatsContextImport.sendTextMessage(textMessage, () => {
          setTextMessage("");
        });
      }
    }
  };

  const callbackStatus = (status: boolean) => {
    console.log(status);
    handleTypingMessage("2", status);
    setRecordingStatus(status);

    setIsRunning(status);
  };

  const captureAudioRecorded = (file: File | null) => {
    console.log(file);
    setIsRunning(false);

    if (chatSelected != null) {
      const flag: string = chatSelected?.flag!;
      if (["1", "4"].includes(flag)) {
        teamChatsContextImport.sendAudioMessage(
          file!,
          audioSecondsRef.current,
          () => {
            setRecordingStatus(false);
            audioSecondsRef.current = 0;
          }
        );
      } else if (flag === "2") {
        departmentChatsContextImport.sendAudioMessage(
          file!,
          audioSecondsRef.current,
          () => {
            setRecordingStatus(false);
            audioSecondsRef.current = 0;
          }
        );
      } else if (flag === "3") {
        groupChatsContextImport.sendAudioMessage(
          file!,
          audioSecondsRef.current,
          () => {
            setRecordingStatus(false);
            audioSecondsRef.current = 0;
          }
        );
      }
    }
  };

  const cancelStopRecording = async () => {
    setCancelRecording(true);
    setRecordingStatus(false);
    setIsRunning(false);

    await UtilityHelper.delay();
    setCancelRecording(false);
    setIsRunning(false);
    audioSecondsRef.current = 0;
  };

  const longPressAction = (action: "reply" | "copy" | "delete" | "forward") => {
    if (chatSelected != null) {
      const flag: string = chatSelected?.flag!;
      let isEveryone: boolean = false;

      if (["1", "4"].includes(flag)) {
        teamChatsContextImport.longPressAction(action);

        if (action === "delete") {
          isEveryone = (teamChatsContextImport.selectedMessages ?? []).every(
            (element: TeamMessage) => element.account_id === userId
          );
        }
      } else if (flag === "2") {
        departmentChatsContextImport.longPressAction(action);

        if (action === "delete") {
          isEveryone = (
            departmentChatsContextImport.selectedMessages ?? []
          ).every((element: Message) => element.account_id === userId);
        }
      } else if (flag === "3") {
        groupChatsContextImport.longPressAction(action);

        /* isEveryone = (groupChatsContextImport.selectedMessages ?? []).every(
          (element: Message) => element.account_id === userId
        ); */
      }

      if (["1", "4"].includes(flag)) {
        dispatch(
          messageDeleteEveryoneAction({ isEveryone: isEveryone, flag: flag })
        );
      }
    }
  };

  const audioTimer = (seconds: number) => {
    audioSecondsRef.current = seconds;
  };

  const adjustHeight = () => {
    if (textareaMessageRef.current) {
      // Reset height to auto before measuring
      textareaMessageRef.current.style.height = "auto";
      // Set the height to the scrollHeight (height of content)
      const heightValue: number = textareaMessageRef.current.scrollHeight;
      textareaMessageRef.current.style.height = `${heightValue}px`;
      setMessageHeight(
        heightValue < messageMaxDefault ? heightValue : messageMaxDefault
      );
    }
  };

  useEffect(() => {
    adjustHeight(); // Adjust the height after each render
  }, [textMessage]);

  return (
    <>
      {[
        teamChatsContextImport.longPressStatus,
        departmentChatsContextImport.longPressStatus,
        groupChatsContextImport.longPressStatus,
      ].includes(true) &&
      (["1", "4"].includes(chatSelected?.flag!)
        ? teamChatsContextImport.selectedMesasgeIds.length
        : chatSelected?.flag === "2"
        ? departmentChatsContextImport.selectedMesasgeIds.length
        : groupChatsContextImport.selectedMesasgeIds.length) > 0 ? (
        <div className="chat-footer p-3 d-flex align-items-center justify-content-between">
          <ChatFooterLongPressMenu
            counter={
              ["1", "4"].includes(chatSelected?.flag!)
                ? teamChatsContextImport.selectedMesasgeIds.length
                : chatSelected?.flag === "2"
                ? departmentChatsContextImport.selectedMesasgeIds.length
                : groupChatsContextImport.selectedMesasgeIds.length
            }
            handleCancel={
              ["1", "4"].includes(chatSelected?.flag!)
                ? teamChatsContextImport.clearLongPress
                : chatSelected?.flag === "2"
                ? departmentChatsContextImport.clearLongPress
                : groupChatsContextImport.clearLongPress
            }
            flag={chatSelected?.flag!}
            longPressAction={longPressAction}
          />
        </div>
      ) : (
        <>
          <ChatFooterReply
            userId={userId}
            flag={chatSelected?.flag!}
            replyDetail={
              ["1", "4"].includes(chatSelected?.flag!) &&
              teamChatsContextImport.replyMessage != null
                ? teamChatsContextImport.replyMessage
                : chatSelected?.flag === "2" &&
                  departmentChatsContextImport.replyMessage != null
                ? departmentChatsContextImport.replyMessage
                : null
            }
            handleCancel={
              ["1", "4"].includes(chatSelected?.flag!)
                ? () => teamChatsContextImport.cancelReply()
                : chatSelected?.flag === "2"
                ? () => departmentChatsContextImport.cancelReply()
                : () => {}
            }
          />
          <Div className="position-relative">
            <Row
              className="chat-footer bgcolor-white px-3 py-2 align-items-end"
              style={{
                minHeight: messageHeight,
                maxHeight: messageMaxDefault,
              }}
            >
              <Col xs={2} sm={1} className="d-center pb-2">
                <span className="pb-1">
                  <IconCircleFilledIcon
                    size={30}
                    name="plus2"
                    color="black"
                    bgColor="bgcolor-theme-bg"
                    wrapBgColor="bgcolor-theme-bg"
                    handleClick={() => toggleMediaOption(null)}
                  />
                </span>
              </Col>
              <Col
                className="p-2 chat-message-input-wrap  d-flex align-items-center justify-content-start mb-1"
                style={{ minHeight: 45 }}
              >
                {recordingStatus ? (
                  <div className="d-flex align-items-center">
                    <IconCircleFilledIcon
                      size={28}
                      name="close"
                      color="white"
                      bgColor="bgcolor-transparent"
                      wrapBgColor="bgcolor-primary"
                      handleClick={cancelStopRecording}
                    />

                    <IconNormal
                      name="recording_icon"
                      color={AppTheme.themeFont}
                    />

                    <TimerMinutesSeconds
                      startStatus={isRunning}
                      callback={audioTimer}
                    />
                  </div>
                ) : (
                  <textarea
                    ref={textareaMessageRef}
                    name="chat-message-input"
                    className="chat-message-input"
                    onChange={(e) => messageHandleChange(e)}
                    value={textMessage}
                    rows={1}
                  />
                )}
              </Col>
              <Col xs={2} sm={1} className="d-center  pb-2">
                <div className="pb-1">
                  {UtilityHelper.isEmpty(textMessage) ? (
                    <AudioRecorder
                      isCancel={cancelRecording}
                      captureAudioRecorded={captureAudioRecorded}
                      callbackStatus={callbackStatus}
                      playButton={
                        <IconCircleFilledIcon
                          size={30}
                          name="mic"
                          color="black"
                          bgColor="bgcolor-theme-bg"
                        />
                      }
                      stopButton={
                        <IconCircleFilledIcon
                          size={30}
                          name="paper_plane"
                          color="black"
                          bgColor="bgcolor-theme-bg"
                        />
                      }
                    />
                  ) : (
                    <IconCircleFilledIcon
                      size={30}
                      name="paper_plane"
                      color="black"
                      bgColor="bgcolor-theme-bg"
                      handleClick={sendTextMessage}
                    />
                  )}
                </div>
              </Col>
            </Row>
            <ChatFooterMedia />
          </Div>
        </>
      )}
    </>
  );
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////
const ChatFooterReply = ({
  flag,
  replyDetail,
  handleCancel,
  userId,
}: {
  flag: string;
  replyDetail: ReplyMessageDetailModel | null;
  userId: string;
  handleCancel: () => void;
}) => {
  let msg: any = "",
    msg2: string = "";

  if (flag !== "3" && replyDetail != null) {
    if (["3", "6", "7", "8"].includes(replyDetail.message_type!)) {
      const arr: Array<string> = replyDetail.decripted_mesage?.split("|")!;
      msg2 = arr[arr.length - 1];
    }

    msg =
      replyDetail.message_type === "2"
        ? "photo"
        : replyDetail.message_type === "4"
        ? "video"
        : replyDetail.message_type === "5"
        ? "location"
        : ["3", "6", "7", "8"].includes(replyDetail.message_type!)
        ? msg2
        : replyDetail.decripted_mesage;
  }

  return (
    <>
      {flag !== "3" && replyDetail != null && (
        <Div className="chat-reply-content px-3 py-2">
          <div>
            <TextBlock
              textColor="black"
              fontName="bold"
              fontSize="12_14"
              maxLine={1}
            >
              {textCase(
                replyDetail.account_id === userId ? "you" : replyDetail!.name!
              )}
            </TextBlock>
            <div className="d-flex align-items-center justify-content-between pe-3">
              <div className="d-flex align-items-center">
                {["2", "3", "4", "5", "6", "7", "8"].includes(
                  replyDetail.message_type!
                ) && (
                  <span className="opacity-04 pe-2">
                    <IconImageAsset
                      name={
                        replyDetail.message_type === "2"
                          ? "camera"
                          : replyDetail.message_type === "3"
                          ? "mic"
                          : replyDetail.message_type === "4"
                          ? "video"
                          : replyDetail.message_type === "5"
                          ? "loc2"
                          : "doc2"
                      }
                      size={12}
                    />
                  </span>
                )}
                <TextBlock
                  textColor="black"
                  fontName="book"
                  fontSize="12_14"
                  maxLine={1}
                  className="pt-1"
                >
                  {textCase(msg)}
                </TextBlock>
              </div>
              {["2"].includes(replyDetail.message_type!) && (
                <div className="preview">
                  <LogoImage
                    url={replyDetail.decripted_mesage!.split("|")[1]}
                    size={35}
                    name="photo"
                    fixedHieght={false}
                  />
                </div>
              )}

              {["5"].includes(replyDetail.message_type!) && (
                <IconImageAsset name="loc_reply_type" size={40} />
              )}
            </div>
          </div>
          <div>
            <IconCircleFilledIcon
              size={28}
              name="close"
              color="black"
              bgColor="bgcolor-white"
              wrapBgColor="bgcolor-white"
              handleClick={handleCancel}
            />
          </div>
        </Div>
      )}
    </>
  );
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////
const ChatFooterLongPressMenu = (props: {
  counter: number;
  handleCancel: () => void;
  flag: string;
  longPressAction: (action: "reply" | "copy" | "delete" | "forward") => void;
}) => {
  return (
    <>
      <Div className="position-relative z-index-1 d-flex align-items-center">
        <IconNormal
          name="close"
          color={AppTheme.black}
          handleClick={() => props.handleCancel()}
        />

        <TextBlock
          fontName="book"
          fontSize="16_17"
          textColor="black"
          className="ms-3"
        >
          {props.counter ?? 0} selected
        </TextBlock>
      </Div>
      <Div className="position-relative z-index-1">
        {(props.counter ?? 0) === 1 && props.flag !== "3" && (
          <>
            <span
              title={AppTranslation.text("reply")}
              className="mx-2"
              role="button"
              onClick={() => props.longPressAction("reply")}
            >
              <IconCircleFilledIcon
                size={32}
                name="rewind"
                color="black"
                bgColor="bgcolor-theme-bg"
              />
            </span>
          </>
        )}

        {(props.counter ?? 0) === 1 && (
          <span
            title={AppTranslation.text("copy")}
            className="mx-2"
            role="button"
            onClick={() => props.longPressAction("copy")}
          >
            <IconCircleFilledIcon
              size={32}
              name="duplicate"
              color="black"
              bgColor="bgcolor-theme-bg"
            />
          </span>
        )}

        {(props.counter ?? 0) > 0 && props.flag !== "3" && (
          <span
            title={AppTranslation.text("delete")}
            className="mx-2"
            role="button"
            onClick={() => props.longPressAction("delete")}
          >
            <IconCircleFilledIcon
              size={32}
              name="trash"
              color="black"
              bgColor="bgcolor-theme-bg"
            />
          </span>
        )}

        <span
          title={AppTranslation.text("forward")}
          className="mx-2"
          role="button"
          onClick={() => props.longPressAction("forward")}
        >
          <IconCircleFilledIcon
            size={32}
            name="forward2"
            color="black"
            bgColor="bgcolor-theme-bg"
          />
        </span>
      </Div>
    </>
  );
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////
const ChatFooterRestrict = ({ title }: { title: string }) => {
  return (
    <ChatFooterWarning>
      <span className="font-gotham-bold font-size-13_14 color-theme-font">
        {AppTranslation.text(title)}
      </span>
    </ChatFooterWarning>
  );
};

const ChatFooterMedia = () => {
  const type: number = ResponsiveDeviceType();
  const dispatch = useDispatch();

  const modals = useSelector((state: RootState) => state.modals.list);

  const { showMediaOption, toggleMediaOption, chatSelected } =
    ChatsContextImport();
  const teamChatsContextImport = TeamChatsContextImport();
  const departmentChatsContextImport = DepartmentChatsContextImport();
  const groupChatsContextImport = GroupChatsContextImport();

  const closeModal = () => {
    if (modals.length > 0) {
      const lastModal: ModalInterface = modals[modals.length - 1];
      if ((lastModal.screenMobileView ?? false) === true) {
        // window.history.back();
      }
    }
  };

  const mediaOption = (option: {
    icon: string;
    title: string;
    tap?: () => void;
  }) => {
    return (
      <div className="px-3 px-lg-4">
        <IconCircleFilledIcon
          size={45}
          name={option.icon}
          color="black"
          bgColor="bgcolor-theme-bg"
          handleClick={option.tap}
        />
        <TextBlock
          fontSize="10_12"
          fontName="medium"
          textColor="black"
          className="pt-2"
          center={true}
        >
          {AppTranslation.text(option.title)}
        </TextBlock>
      </div>
    );
  };

  const getEditedFile = (file: File | null, durationSeconds: number = 0) => {
    if (file != null) {
      if (["1", "4"].includes(chatSelected?.flag!)) {
        teamChatsContextImport.sendMediaMessage(file, durationSeconds, () => {
          toggleMediaOption(false);
          closeModal();
        });
      } else if (chatSelected?.flag === "2") {
        departmentChatsContextImport.sendMediaMessage(
          file,
          durationSeconds,
          () => {
            toggleMediaOption(false);
            closeModal();
          }
        );
      } else if (chatSelected?.flag === "3") {
        groupChatsContextImport.sendMediaMessage(file, durationSeconds, () => {
          toggleMediaOption(false);
          closeModal();
        });
      }
    }
  };

  const handleLocation = () => {
    toggleMediaOption(false);
    dispatch(
      addModal({
        id: ModalKeys.chat_location,
        title: "send_location",
        size: "lg",
        screenMobileView: type === 3 ? false : true,
      })
    );
  };

  const handleCamera = () => {
    //toggleMediaOption(false);
    dispatch(
      addModal({
        id: ModalKeys.chat_camera,
        title: "camera",
        size: "lg",
        screenMobileView: type === 3 ? false : true,
      })
    );
  };

  return (
    <>
      <div
        className={`chat-footer-media  py-3 px-4 d-center  ${
          showMediaOption ? "show" : ""
        }`}
      >
        <div className="position-relative d-center z-index-1">
          {mediaOption({
            icon: "camera",
            title: "camera",
            tap: () => handleCamera(),
          })}

          <ImageEditorPick
            fromAction="chat"
            callback={getEditedFile}
            onClick={() => {}}
          >
            {mediaOption({
              icon: "gallery",
              title: "gallery",
            })}
          </ImageEditorPick>

          <FileDocumentPicker
            fromAction="chat"
            callback={getEditedFile}
            onClick={() => {}}
          >
            {mediaOption({
              icon: "document",
              title: "docs",
            })}
          </FileDocumentPicker>

          {mediaOption({
            icon: "chat_location",
            title: "location",
            tap: () => {
              handleLocation();
            },
          })}
        </div>
      </div>
    </>
  );
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////
export const ChatFooterWarning = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return (
    <div className="chat-footer-warning  px-3 py-2 d-center">
      <div className="chat-footer-warning-body  ellipsis line-2 text-center font-gotham-book color-black font-size-14_15">
        {children}
      </div>
    </div>
  );
};
